import React from 'react';
import Modal from '../common/Modal';

interface TranscriptModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  transcript: string | null;
}

export default function TranscriptModal({
  isOpen,
  onClose,
  title,
  transcript,
}: TranscriptModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} maxWidth="5xl">
      <div className="max-h-[70vh] overflow-y-auto">
        {transcript ? (
          <div
            className="font-body text-base text-foreground leading-relaxed whitespace-pre-wrap"
            style={{ lineHeight: 1.75 }}
            dangerouslySetInnerHTML={{ __html: transcript }}
          />
        ) : (
          <p className="font-body text-muted-foreground italic">No transcript available.</p>
        )}
      </div>
    </Modal>
  );
}
